// Customer portal — development.
// Same Firebase project as the admin dashboard (one Auth user directory, one
// Firestore), but the portal reaches data ONLY through the /portal cloud API,
// which scopes every request to the caller's kundekort. Firebase here is used
// for authentication and nothing else — see projects/portal/PORTAL.md.
export const environment = {
  production: false,
  apiUrl: "https://europe-west1-frigg-kantine.cloudfunctions.net",
  portalApi: "https://europe-west1-frigg-kantine.cloudfunctions.net/widgets/portal",
  supportEmail: "post@cuboid.no",
  firebaseConfig: {
    apiKey: "AIzaSyA7aKWOp-LQNkE6PZ8KNL1CNvSifkPYZEI",
    authDomain: "frigg-kantine.firebaseapp.com",
    projectId: "frigg-kantine",
    databaseURL: "https://frigg-kantine.firebaseio.com",
    storageBucket: "frigg-kantine.appspot.com",
    messagingSenderId: "308881591789",
    appId: "1:308881591789:web:ca4f20ef745f8d05636be4",
    measurementId: "G-GZPTHWTBBZ"
  }
};
